import { render } from "./VoiceOverRecorder.vue?vue&type=template&id=338a47bd"
import script from "./VoiceOverRecorder.ts?vue&type=script&lang=js"
export * from "./VoiceOverRecorder.ts?vue&type=script&lang=js"

import "./VoiceOverRecorder.vue?vue&type=style&index=0&id=338a47bd&lang=css"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__